import React, { useState } from "react";
import { Title } from "styled/Title";
import "./styleForm.css";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { isValid } from "utils/type-check-utils";

export const CiCorrectionLog = ({ title, item, form = {} }) => {
  const [ShowMoreState, setShowMoreState] = useState(false);
  const navigate = useNavigate();

  const handleRouteCorrec = (elemento) => {
    if (elemento.date_statusIntegrationCertificateCorrected) {
      return `/ShowIntegrationBox?idCorrected=${elemento.id}`;
    } else {
      return `/FormCorrectionOutput?ShowOutput=${elemento.id}`;
    }
  };

  const ShowMore = () => {
    setShowMoreState((prev) => !prev);
  };

  const {
    id,
    date_statusIntegrationCertificateCorrected,
    final_balance_adjustment
  } = form || {};



  return (
    <div id="adventenciaReturn" className="my-2 ms-2">
      <div className="d-flex">
        <div>
          <Title size={"18px"} weight={400}>
            {title && title}
          </Title>
          {item &&
            item.map((elemento, index) => (
              <>
                <span key={index}>
                  Creada:{" "}
                  {elemento.date_statusIntegrationCertificateCorrected }
                  .
                  <NavLink
                    to={handleRouteCorrec(elemento)}
                    className="ms-2 correction-link"
                  >
                    Ver corrección.
                  </NavLink>
                  <br />
                </span>
              </>
            ))}

          {ShowMoreState && <div /* className="ms-2" */>Creada: {date_statusIntegrationCertificateCorrected }</div>}
        </div>
      </div>
    </div>
  );
};
